import { Card } from '@transferz/fe-component-library/src/components/card/Card';
import Email from '@transferz/fe-component-library/src/components/icons/EmailIcon';
import Phone from '@transferz/fe-component-library/src/components/icons/PhoneIcon';
import User from '@transferz/fe-component-library/src/components/icons/UserIcon';
import Typography from '@transferz/fe-component-library/src/components/typography/Typography';
import { JourneyStatusType } from '@transferz/fe-models';
import { useLocalize } from 'localize-react';
import React, { useState } from 'react';

export const PassengerDetails: React.FC<any> = ({ journey }) => {
  const { translate } = useLocalize();
  const [isCollapsed, setIsCollapsed] = useState(journey?.status !== JourneyStatusType.Pending);

  const onCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="passenger-details card-wrap">
      <Card title={translate('passengerDetailsTitle')} onCollapse={onCollapse} collapsed={isCollapsed}>
        <div className="d-flex mb-24">
          <User />
          <Typography variant="body1">
            {journey?.travellerInfo?.firstName} {journey?.travellerInfo?.lastName}
          </Typography>
        </div>
        {journey?.travellerInfo?.displayEmailAllowed && journey?.travellerInfo?.email && (
          <div className="d-flex mb-24">
            <Email />
            <Typography variant="body1">
              {journey?.travellerInfo?.email}
            </Typography>
          </div>
        )}
        {journey?.travellerInfo?.phone && (
          <div className="d-flex mb-12">
            <Phone height="20" />
            <Typography variant="body1">
              {journey?.travellerInfo?.phone}
            </Typography>
          </div>
        )}
      </Card>
    </div>
  );
};
